import useDefinedContext from "hooks/useDefinedContext";
import SetChartSelectionsContext from "components/charting/contexts/SetChartSelectionsContext";

function useSetChartSelections() {
  return useDefinedContext(SetChartSelectionsContext);
}
export default useSetChartSelections;
